import { Button, Card, CardContent, CardDescription, CardHeader, Separator } from '@noissue/os-ui';
import { signIn, signInWithGoogle } from '../auth-client';
import { Logo } from './logo';

/*
 * Dev-only persona switcher. Rendered only when VITE_DEV_AUTH is set; it signs in
 * as a seeded persona via the email/password provider (which the server only
 * enables under DEV_AUTH_BYPASS). Emails + password must match dev-personas.ts.
 */
const DEV_AUTH = import.meta.env.VITE_DEV_AUTH === 'true';
const DEV_PASSWORD = 'devpassword';
const DEV_PERSONAS = [
  { email: 'admin@noissue.co', label: 'Admin — admin + quoting' },
  { email: 'quoting@noissue.co', label: 'Quoter — quoting only' },
  { email: 'manager@noissue.co', label: 'Sales manager — quotes + approvals' },
  { email: 'leader@noissue.co', label: 'Leader — company roadmap' },
  { email: 'leader2@noissue.co', label: 'Second leader — company roadmap' },
  { email: 'logistics@noissue.co', label: 'Logistics — answers freight RFQs' },
  { email: 'sourcing@noissue.co', label: 'Sourcing — answers product RFQs' },
  { email: 'support@noissue.co', label: 'Support — erases customer data' },
  { email: 'viewer@noissue.co', label: 'Viewer — no module access' },
];

/** Public route. The hosted-domain (noissue.co) restriction is enforced server-side. */
export function LoginPage() {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center pb-1">
            <Logo className="h-6 w-auto text-primary" />
            {/* The sidebar's label, scaled with the logo: 12 px beside a 20 px logo, 14 beside 24. */}
            <span className="ml-[2px] text-[14px] font-semibold tracking-tight text-[#2C1847]">
              OS
            </span>
          </div>
          <CardDescription>Sign in with your noissue.co Google account.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button className="w-full" onClick={() => signInWithGoogle('/')}>
            Continue with Google
          </Button>

          {DEV_AUTH && (
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Separator className="flex-1" /> dev sign-in <Separator className="flex-1" />
              </div>
              {DEV_PERSONAS.map((p) => (
                <Button
                  key={p.email}
                  variant="outline"
                  className="w-full justify-start"
                  onClick={() =>
                    signIn
                      .email({ email: p.email, password: DEV_PASSWORD })
                      .then(() => (window.location.href = '/'))
                  }
                >
                  {p.label}
                </Button>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
